var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_270_733)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9062 17.5312H31.9375V27.8438H30.9062C30.3391 27.8438 29.875 27.3797 29.875 26.8125V24.7436H21.8055C21.7442 24.75 21.6862 24.7532 21.625 24.7532C20.4874 24.7532 19.5625 23.8283 19.5625 22.6907V22.1235C20.7227 22.7906 22.1825 22.8841 23.4684 22.2396C24.2128 21.8689 24.7929 21.3018 25.1828 20.6347H29.8718V18.5625C29.8718 17.9953 30.3358 17.5312 30.903 17.5312H30.9062ZM21.5992 14.4375C21.6089 14.4375 21.6153 14.4375 21.625 14.4375H21.6443C21.6282 14.4375 21.6153 14.4375 21.5992 14.4375Z",
    fill: "#66CC33"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7778 21.6981L9.73662 23.7188L7.89326 20.0288L10.0879 18.9299L13.7778 21.6981Z",
    fill: "#66CC33"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5222 17.4797C25.07 18.9428 24.4352 20.6153 23.0075 21.3275C21.5799 22.043 19.8622 21.5467 19.0211 20.2286L16.8716 21.3018C16.1561 21.6595 15.3537 21.5886 14.7124 21.1084L10.7066 18.1049C10.3876 17.8632 9.98476 17.8277 9.62705 18.0082L7.4292 19.1071C7.07148 19.2876 6.66865 19.2489 6.34961 19.0105L4.50625 17.6279C4.21299 17.4088 4.06474 17.0769 4.09697 16.7095C4.1292 16.3421 4.33545 16.0456 4.66416 15.8813L24.0355 6.19717C26.069 5.18203 28.5537 6.01026 29.5688 8.04375L31.4122 11.7337C31.9214 12.7488 31.5057 13.9928 30.4905 14.502L24.5222 17.4861V17.4797ZM21.625 17.5313C22.1954 17.5313 22.6562 17.9921 22.6562 18.5625C22.6562 19.1329 22.1954 19.5938 21.625 19.5938C21.0546 19.5938 20.5937 19.1329 20.5937 18.5625C20.5937 17.9921 21.0546 17.5313 21.625 17.5313Z",
    fill: "#66CC33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_270_733",
    x: -3,
    y: 0,
    width: 41,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_270_733"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_270_733",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraGreen);
export default __webpack_public_path__ + "static/media/camera-green.f3a5f6c4f6ac743421be375f8e2ec17e.svg";
export { ForwardRef as ReactComponent };